<template>
    <div class="menu" v-show="this.$route.path != '/'">
            <nav class="nav nav">
                <div class="nav__trigger" :class="{active:isActive}" @click="isActive = !isActive;"><i></i></div>
                <ul class="nav__list" style="position:fixed" :class="{active:isActive}">
                    <router-link class="nav__link itemList" @click.native="isActive = !isActive;" to="/itemList/1">商品一覧</router-link>
                    <router-link class="nav__link saleRegister" @click.native="isActive = !isActive;" to="/auctionRegister">出品登録</router-link>
                    <router-link class="nav__link userSetting" @click.native="isActive = !isActive;" to="/userSetting">ユーザー管理</router-link>
                    <router-link class="nav__link earnings" @click.native="isActive = !isActive;" to="/sell">コメント管理</router-link>
                    <router-link class="nav__link delivery" @click.native="isActive = !isActive;" to="/trading">取引中商品管理</router-link>
                    <!-- <div class="nav__link delivery" :disabled="true">配送管理</div> -->
                    <router-link class="nav__link err" @click.native="isActive = !isActive;" to="/fixedPhrase">定型文登録</router-link>
                    <router-link class="nav__link infomation" @click.native="isActive = !isActive;" to="/infomation">インフォメーション</router-link>
                    <router-link class="nav__link logout" @click.native="isActive = !isActive;" to="/">ログアウト</router-link>
                    <!-- <div class="nav__link " :disabled="true"></div> -->
                    <!-- <router-link class="nav__link earnings" @click.native="isActive = !isActive;" to="earnings" :disabled="true">売上管理</router-link> -->
                </ul>
            </nav>
        </div>
</template>
<script>
export default {
    
  data() {
        return {
            isActive: false
        }
  }
}
</script>

<style scoped lang="scss">

.itemList{
  background: url(../assets/menu/itemList.png)  no-repeat;
}
.saleRegister{
  background: url(../assets/menu/sale.png)  no-repeat;
}
    
.userSetting{
  background: url(../assets/menu/user.png)  no-repeat;
}
.earnings{
  background: url(../assets/menu/earnings.png)  no-repeat;
}
.delivery{
  background: url(../assets/menu/delivery.png)  no-repeat;
}
.err{
  background: url(../assets/menu/err.png)  no-repeat;
}
.infomation{
  background: url(../assets/menu/infomation.png)  no-repeat;
}
.logout{
  background: url(../assets/menu/logout.png)  no-repeat;
}

// Nav ----------
// ------------------------------------------------

.nav {
	display: flex;
}

.nav__trigger {
  width: 24px;
  height: 24px;
  position: fixed;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 500;
  
  i {
    transition-property: transform background-color;
    transition-duration: 0.3s;
    transition-delay: 0.3s;
    width: 100%;
    height: 3px;
    position: absolute;
    top: 8px;
    left: 0;
    background-color: #fff;
    
    &:before,
    &:after {
      content:"";
      transition-property: transform background-color;
      transition-duration: 0.3s;
      transition-delay: 0.3s;
      width: 100%;
      height: 3px;
      position: absolute;
      left: 0;
      background-color: #fff;
    }
    
    &:before {
      top: -8px;
    }
    
    &:after {
      top: 8px;
    }
  }
  
  // active -------------------------------
  &.active {
    i {
      background-color: transparent;

      &:before,
      &:after {
        top: 0px;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}

.nav__list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  transition-property: visibility;
}

.nav__link {
  $bg-color: #333;
  display: block;
  background-color: $bg-color;
  background-position: center;
  background-size: 50%;
  padding: 20px;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  outline: 1px solid rgba(0,0,0,0.15);
  
  &:hover {
    background-color: lighten($bg-color,7%);
  }
}


//-----------------------------------------


.nav {
	$items: 4;
	$duration: 0.4s;
	$delay: 0.2s;
	
  &__list {
		@extend .nav__list;
		transition-delay: $duration + $delay * $items;
		perspective: 150px;
		z-index: 100;
		&.active {
			transition-delay: 0s;
			visibility: visible;
			.nav__link {
				transform: translateY(0px) translateZ(0px);
				opacity: 1;
			}
		}
  }
  
  &__link {
    @extend .nav__link;
    // z-index: 100;
    transition:
    transform $duration ease-in-out,
    opacity $duration ease-in-out;
    transform: translateY(0px) translateZ(-150px);
    width: 50%;
    height:25%;
    float: left;
    opacity: 0;
    
    @for $i from 0 through $items {
      &:nth-child(#{$i + 1}) {
        transition-delay: $i * $delay;
      }  
    }
  }
}
</style>